module.exports = __webpack_public_path__ + "static/media/doctor-profile08.b8509fc0.jpg";